export const resultSchema = `
            result
            createdDateTime
            batchId
            correlationId
            objectId
            object
            eventId
            description
            action
            eventType
            errorNumber
            errorDescription
            trace
    `;
